/* ThroatClear — interacciones (prefijo tc-) */
(function () {
  if (window.__tcLoaded) return;
  window.__tcLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.tc-reveal:not(.tc-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var eu = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, eu);
    }
    return eu + ' €';
  }

  function initProducto() {
    var root = document.querySelector('[data-tc-pdp]');
    if (!root || root.dataset.tcBound) return;
    root.dataset.tcBound = '1';
    var dataEl = root.querySelector('[data-tc-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var fmt = root.getAttribute('data-money-format');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-tc-price]');
    var compareEl = root.querySelector('[data-tc-compare]');
    var saveEl = root.querySelector('[data-tc-save]');
    var btn = root.querySelector('[data-tc-add]');
    var btnLabel = btn ? btn.querySelector('[data-tc-add-label]') : null;
    var sticky = document.querySelector('[data-tc-sticky]');
    var stickyPrice = sticky ? sticky.querySelector('[data-tc-sticky-price]') : null;
    var mainImg = root.querySelector('[data-tc-main]');
    var txtAdd = btn ? btn.getAttribute('data-txt-add') : '';
    var txtSold = btn ? btn.getAttribute('data-txt-sold') : '';

    // Galería
    root.querySelectorAll('[data-tc-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-src');
        mainImg.srcset = '';
        root.querySelectorAll('[data-tc-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-tc-option]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function update() {
      var opts = currentOptions();
      root.querySelectorAll('.tc-opt').forEach(function (l) {
        var i = l.querySelector('input');
        l.classList.toggle('is-checked', !!(i && i.checked));
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (stickyPrice) stickyPrice.textContent = money(v.price, fmt);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price, fmt);
          compareEl.hidden = false;
          if (saveEl) {
            saveEl.textContent = saveEl.getAttribute('data-prefix') + ' ' + money(v.compare_at_price - v.price, fmt);
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? txtAdd : txtSold;
      }
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image;
        mainImg.srcset = '';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-tc-option] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
    update();

    // Cantidad
    var qty = root.querySelector('[data-tc-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelector('[data-minus]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      qty.querySelector('[data-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    }

    // Barra fija de compra en móvil
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !e.isIntersecting && below);
        });
      }).observe(btn);
      sticky.querySelector('button').addEventListener('click', function () {
        var form = root.querySelector('form[action*="/cart/add"]');
        if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
      });
    }
  }

  function init() { initReveal(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
